module.exports = __webpack_public_path__ + "img/list_default10.baa44230.png";